module.exports = __webpack_public_path__ + "static/wclogo-b0a85551f36fbe40645a31df2d51ea97.png";